import { useMutation, useQueryClient } from '@tanstack/react-query';

import { toast } from 'sonner';

import { serviceServices } from '../services/service.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status:
      error?.response?.status || 500,

    errors:
      error?.response?.data?.errors || [],
  };
};

/**
 * Update service
 */
export const useUpdateService = () => {

  const queryClient =
    useQueryClient();

  return useMutation({

    mutationFn: async ({
      serviceId,
      data,
    }) => {
      try {

       return await serviceServices.updateService({
  serviceId,
  data,
});

      } catch (error) {

        throw parseApiError(error);

      }
    },

    onSuccess: () => {

      toast.success(
        'Service updated successfully'
      );

      queryClient.invalidateQueries({
        queryKey: ['services'],
      });
    },

    onError: (error) => {

      toast.error(
        error?.message ||
          'Failed to update service'
      );

    },
  });
};